import { render } from "./inspectionManage.vue?vue&type=template&id=1982737b&scoped=true"
import script from "./inspectionManage.vue?vue&type=script&lang=js"
export * from "./inspectionManage.vue?vue&type=script&lang=js"

import "./inspectionManage.vue?vue&type=style&index=0&id=1982737b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1982737b"]])

export default __exports__